<template>
  <nuxt />
</template>

<script>
export default {
  layout: 'empty',
  errorCaptured(error, vm, info) {
    this.$sentry.captureException({ error, vm, info })
  },
}
</script>
